<template>
  <van-skeleton
    avatar
    avatar-shape="square"
    avatar-size="100"
    :row="2"
    :loading="loading"
  >
    <van-row
      :gutter="gutter"
      type="flex"
      align="top"
      :class="customClass"
      @click="click"
    >
      <van-col :span="iconSpan">
        <van-image
          :src="episodeData.cover.private_cdns[0].cdn_url"
          radius="5"
        />
        <!-- <ShowImage
          source="cdn"
          :imgId="episodeData.cover.id"
          :radius="5"
        /> -->
      </van-col>
      <van-col :span="bodySpan" :offset="offset">
        <strong>{{episodeData.title}}</strong>
        <div v-if="showDescription" class="van-multi-ellipsis--l2 desc">
          {{episodeData.description}}
        </div>
        <van-row gutter="15" type="flex" justify="start" align="center" class="meta">
          <!-- <van-col v-if="showPrice" span="">
            <span class="price">{{price}}</span>
            <span
              v-if="priceOrigin"
              class="price-origin"
            >{{priceOrigin}}</span>
          </van-col> -->
          <priceTag
            :episode-id="episodeData.id"
            :voucher-id="voucherId"
            :show-price="showPrice"
            :price="price"
            :price-origin="priceOrigin"
            @voucher-update-success="voucherUpdateSuccess"
          />
          <van-col span="">
            {{duration}}
          </van-col>
          <van-col v-if="showPubtime">
            {{datetime}}
          </van-col>
          <van-col v-if="showRating">
            <div style="display:flex;align-items:center;">
              <van-rate
                v-model="rateValue"
                allow-half
                void-icon="star"
                void-color="#eee"
                size="14"
                readonly
              />
            </div>
          </van-col>
        </van-row>
      </van-col>
    </van-row>
  </van-skeleton>
</template>

<script>
  import {humanDuration, humanDateTime} from '../utils/time.js'
  // import ShowImage from './show-image.vue'
  import priceTag from './price-tag.vue'
  import Vue from 'vue'
  // import { Row, Col } from 'vant'
  import { Row } from 'vant'
  import { Image } from 'vant'
  import { Skeleton } from 'vant'
  import { Rate } from 'vant'
  // Vue.use(Row).use(Col)
  Vue.use(Row)
  Vue.use(Image)
  Vue.use(Skeleton)
  Vue.use(Rate)

  export default {
    components: {
      // ShowImage
      priceTag
    },
    props: {
      episode: {
        type: Object,
        default: function () {
          return {
            title: '',
            description: '',
            price: {
              amount: 0,
              origin: 0
            },
            cover: {
              private_cdns: [{ "cdn_url": "" }]
            }
          }
        }
      },
      parentCommentId: Number,
      compact: { // 紧凑模式
        type: Boolean,
        default: false
      },
      showDescription: { // 显示简介
        type: Boolean,
        default: true
      },
      showPrice: { // 显示价格
        type: Boolean,
        default: true
      },
      showRating: { // 显示评分
        type: Boolean,
        default: false
      },
      showPubtime: { // 显示发布时间
        type: Boolean,
        default: true
      },
      voucherId: {
        type: Number,
        default: null
      }
    },
    computed: {
      gutter () {
        if (this.compact) {
          return 0
        } else {
          return 15
        }
      },
      offset () {
        if (this.compact) {
          return 1
        } else {
          return 0
        }
      },
      iconSpan () {
        if (this.compact) {
          return 3
          // return 6
        } else {
          // return 5
          return 8
        }
      },
      bodySpan () {
        if (this.compact) {
          return 21
          // return 18
        } else {
          // return 19
          return 16
        }
      },
      customClass () {
        if (this.compact) {
          return 'compact'
        } else {
          return null
        }
      },
      duration () {
        return humanDuration(this.episodeData.seconds)
      },
      datetime () {
        return humanDateTime(this.episodeData.created)
      },
      price () {
        let price = this.episodeData.price.amount / 100
        let price_tag
        if (price == 0) {
          price_tag = '免费'
        } else {
          price_tag = '¥' + String(price.toFixed(2))
        }
        return price_tag
      },
      priceOrigin () {
        let price = this.episodeData.price.amount / 100
        let origin_price = this.episodeData.price.origin / 100
        let price_origin
        if (price == origin_price) {
          price_origin = null
        } else {
          price_origin = '¥' + String(origin_price.toFixed(2))
        }
        return price_origin
      }
      // loading () {
      //   if (this.episodeData.title.length > 0) {
      //     return false
      //   } else {
      //     return true
      //   }
      // }
    },
    watch: {
    },
    data () {
      return {
        rateValue: 4.5,
        loading: false,
        episodeData: this.episode
      }
    },
    methods: {
      click () {
        this.$router.replace({
          name: 'EpisodeDetail',
          params: {
            episodeId: this.episodeData.id
          }
        })
      },
      voucherUpdateSuccess: function () {
        // window.console.log("收到 Voucher 更新成功事件通知")
        this.$emit('voucher-update-success')
      }
    },
    mounted () {

    }
  }
</script>

<style lang="css" scoped>
  .desc {
    margin: 5px 0;
    color: #666;
    line-height: 125%;
  }
  .meta {
    font-size: 0.9em;
    color: #999;
  }
  .price {
    color: #e9192d
  }
  .price-origin {
    margin-left: 5px;
    text-decoration: line-through;
  }
  div.compact {
    background: #fafafa;
    padding: 2px 5px;
    display: flex;
    align-items: center;
  }
  img.compact {
    display: block;
    margin-right: 15px;
  }
</style>
